import { withAuthenticationRequired } from '@auth0/auth0-react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import { POST_AUTH_REDIRECT_KEY } from '../../hooks/useAuth'

interface ProtectedRouteProps {
  children: React.ReactNode
  userType: 'creator' | 'brand'
}

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-16 h-16 border-4 border-primary-blue border-t-transparent rounded-full animate-spin"></div>
    </div>
  )
}

function Route_inner({ children, userType }: ProtectedRouteProps) {
  const { user, loading } = useAuthStore()

  if (loading || !user)
    return <Loading />

  if (user.user_type != userType)
    return <Navigate to={`/${user.user_type}/dashboard`} replace />

  return <>{children}</>
}

const Auth_route_inner = withAuthenticationRequired(Route_inner, {
  onRedirecting: () => {
    localStorage.setItem(POST_AUTH_REDIRECT_KEY,
      window.location.pathname + window.location.search)
    return <Loading />
  },
})

export default function ProtectedRoute(props: ProtectedRouteProps) {
  return <Auth_route_inner {...props} />
}